<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    content-class="confirm-dialog"
    @keydown.esc="cancel"
    @keydown.enter="agree"
  >
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4">{{ message }}</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click.native="cancel">
          <v-icon left>$mdi-close</v-icon> {{ $t("btn.no") }}
        </v-btn>
        <v-btn color="primary" text @click.native="agree">
          <v-icon left>$mdi-check</v-icon> {{ $t("btn.yes") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      color: "primary",
      width: 290,
      zIndex: 200,
    },
  }),
  methods: {
    /**
     * Show confirm dialog message
     */
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    /**
     * Handle agree-btn click
     */
    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    /**
     * Handle cancel-btn click
     */
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss">
.confirm-dialog {
  top: 150px;
  position: absolute;
}
</style>
